export default "__VITE_ASSET__af829a6c__"